import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';

import MainDashboard from "../agencyRevenue/MainDashboard";
import DailyAttendance from "../../containers/DailyAttendanceContainer";
import DailyActivity from "../../containers/DailyActivityContainer";
import AgencyPerformance from "../../containers/AgencyPerformanceContainer";
import RevenueGoal from "../../containers/RevenueGoalContainer";
import AdminHome from "../../containers/AdminHomeContainer";
import KPIReport from "../../containers/AgencyKPIReportContainer";


export default class Home extends Component {

    addActiveClass = (event) => {
        let el = event.currentTarget;

        let elements = document.querySelectorAll(".main-tab .nav-link");
        Array.prototype.forEach.call(elements, node => node.className = 'nav-link');

        el.className = 'nav-link pb-2 active';
    };

    tempComponent = () => {
        return (
            <div style={{
                textAlign:"center", paddingTop: "5%", paddingBottom: "5%", color:"red"
            }}><h1>Work in Progress...</h1> <i className="fa fa-flag fa-lg"></i></div>
        );
    };

    render = () => {
        const activeTab = window.location.hash.length > 1 ? 
            window.location.hash.substring(1) : 'home';

        return (
            <section className="container-fluid body-main-container">
                <div className="clearfix"></div>
                <div className="card card-section">
                    <div className="card-header py-0">
                        <ul className="main-tab nav nav-tabs border-0" role="tablist">
                            <li className="nav-item">
                                <NavLink to="home" 
                                    className={`nav-link pb-2 ${activeTab === 'home' ? 'active': ''}`} 
                                    onClick={this.addActiveClass}
                                >
                                    Main Dashboard
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="home#dailyActivity" 
                                    className={`nav-link pb-2 ${activeTab === 'dailyActivity' ? 'active': ''}`} 
                                    onClick={this.addActiveClass}
                                >
                                    <span className="hidden-sm-up"></span>
                                    <span className="hidden-xs-down">Daily Activity Report</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="home#kpiReport" 
                                    className={`nav-link pb-2 ${activeTab === 'kpiReport' ? 'active': ''}`} 
                                    onClick={this.addActiveClass}
                                >
                                    <span className="hidden-sm-up"></span>
                                    <span className="hidden-xs-down">KPI Report</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="home#revenue" 
                                    className={`nav-link pb-2 ${activeTab === 'revenue' ? 'active': ''}`} 
                                    onClick={this.addActiveClass}
                                >
                                    <span className="hidden-sm-up"></span>
                                    <span className="hidden-xs-down">Agency Revenue</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="home#performance" 
                                    className={`nav-link pb-2 ${activeTab === 'performance' ? 'active': ''}`} 
                                    onClick={this.addActiveClass}
                                >
                                    <span className="hidden-sm-up"></span>
                                    <span className="hidden-xs-down">Agency Performance</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="home#attendance" 
                                    className={`nav-link pb-2 ${activeTab === 'attendance' ? 'active': ''}`} 
                                    onClick={this.addActiveClass}
                                >
                                    <span className="hidden-sm-up"></span>
                                    <span className="hidden-xs-down">Daily Attendance</span>
                                </NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="home#revenueGoal" 
                                    className={`nav-link pb-2 ${activeTab === 'revenueGoal' ? 'active': ''}`} 
                                    onClick={this.addActiveClass}
                                >
                                    <span className="hidden-sm-up"></span>
                                    <span className="hidden-xs-down">Agency Revenue Goal</span>
                                </NavLink>
                            </li>
                            <li className="nav-item d-none">
                                <NavLink to="home#compensationPlans" 
                                    className={`nav-link pb-2 ${activeTab === 'compensationPlans' ? 'active': ''}`} 
                                    onClick={this.addActiveClass}
                                >
                                    <span className="hidden-sm-up"></span>
                                    <span className="hidden-xs-down">Compensation Plans</span>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className={`card-body ${activeTab === 'home' ? "border-0 p-0 bg-e" : ""}`}>
                        {activeTab === "attendance" ? 
                            <DailyAttendance />
                        :
                        activeTab === "revenue" ? 
                            <MainDashboard showConfirmModal={this.props.showConfirmModal} 
                            history={this.props.history} />
                        :
                        activeTab === "dailyActivity" ? 
                            <DailyActivity />
                        :
                        activeTab === "performance" ? 
                            <AgencyPerformance />
                        :
                        activeTab === "revenueGoal" ? 
                            <RevenueGoal />
                        :activeTab === "compensationPlan" ? 
                            this.tempComponent()
                        :
                        activeTab === "kpiReport" ? 
                            <KPIReport />
                        :
                            <AdminHome />
                        }
                    </div>
                </div>
            </section>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/home/Home.js